import angular from 'angular'

import VdSuggestionFormatter from './vd-suggestion-formatter'
import VdSuggestionListComponent from './vd-suggestion-list.component'
import VdSuggestionPopoverService from './vd-suggestion-popover.service'
import VdSuggestionSource from './vd-suggestion-source'
import VdSuggestionComponent from './vd-suggestion.component'

angular
  .module('vend.ui')
  .component('vdSuggestion', VdSuggestionComponent)
  .component('vdSuggestionList', VdSuggestionListComponent)
  .factory('VdSuggestionSource', VdSuggestionSource)
  .factory('VdSuggestionFormatter', VdSuggestionFormatter)
  .service('vdSuggestionPopover', VdSuggestionPopoverService)
